import { RegistrationSimpleDialog } from '@rhg/components/registration/registration-simple-dialog';
import commonMessages from '@rhg/lang/messages/common';
import { Typography } from '@rhg/libs/material';
import { useIntl } from 'react-intl';
import consentStepMessages from '../messages';

export function ConsentRequiredDialog({
    setIsDialogOpen,
}: {
    setIsDialogOpen: (isOpen: boolean) => void;
}) {
    const { formatMessage } = useIntl();

    const onClose = () => setIsDialogOpen(false);

    return (
        <RegistrationSimpleDialog
            trackDialog="NoAccessCode"
            title={formatMessage(consentStepMessages.consentDialogTitle)}
            content={
                <Typography variant="body1" color="text.body" align="center">
                    {formatMessage(consentStepMessages.consentDialogContent)}
                </Typography>
            }
            onClose={onClose}
            buttons={[
                {
                    variant: 'text',
                    title: formatMessage(commonMessages['common.close']),
                    trackButton: 'Close',
                    onClick: onClose,
                },
            ]}
        />
    );
}
